export default __webpack_public_path__ + "static/media/iOSAppStoreIcon.f5c0bf7f.svg";